import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  calendarRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  },
  weekDaysWrapper: {
    display: 'inline-flex',
  },
  weekRow: {
    display: 'inline-flex',
  },
  weekDay: {
    fontSize: 15,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  daysWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  day: {
    width: 35,
    height: 35,
    borderRadius: '50%',
  },
  monthPickerWrapper: {
    marginBottom: 5,
  },
}));
